import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import { DEFAULT_EDIT_AVAILABLE_CODES_OPTION } from '../../(dashboards)/programs/constants'
interface TransitValidationState {
  businessUser: BaseBusinessUser
  programDetail: BaseProgram
}

const initialBusinessUser: BaseBusinessUser = {
  BusinessUserID: '',
  Email: '',
  Name: '',
  Description: '',
  CreatedAtUTC: null,
  JoinedAtUTC: null,
  Status: '',
  ImageID: '',
  imageUrl: null,
  Deleted: false,
  IsSuspended: false,
  ActivePrograms: 0,
  Location: null
}

const initialProgramDetail: BaseProgram = {
  ProgramID: null,
  BusinessUserID: null,
  Name: null,
  Description: null,
  StartDateUTC: null,
  EndDateUTC: null,
  DistributionType: null,
  TotalRewards: null,
  UserLimit: null,
  ValueOfTrip: null,
  joinMethod: null,
  EnterCode: false,
  CodeGenerationMethod: null,
  NumberOfCodes: null,
  Prefix: null,
  ExcludedCharacters: null,
  CodeLength: null,
  TimesCanBeEnteredByUser: null,
  ScanReceipt: false,
  Status: null,
  BusinessName: null,
  Deleted: false,
  CreatedAtUTC: null,
  IsHidden: false,
  availableCodesCount: 0,
  redeemedCodesCount: 0,
  editAvailableCodesType: DEFAULT_EDIT_AVAILABLE_CODES_OPTION,
  availableTime: [],
  setDayTime: false,
  setPurchaseDay: false,
  setPurchaseTime: false,
  purchaseDays: [],
  purchaseTimes: [],
  setReceiptAmount: false,
  receiptAmountOption: null,
  ReceiptMinAmount: null,
  ReceiptMaxAmount: null,
  NumberOfReceipts: null
}

const initialState: TransitValidationState = {
  businessUser: initialBusinessUser,
  programDetail: initialProgramDetail
}

export const transitValidationSlice = createSlice({
  name: 'transitValidation',
  initialState,
  reducers: {
    setBusinessUser: (state, action: PayloadAction<BaseBusinessUser>) => {
      state.businessUser = action.payload
    },
    setProgramDetail: (state, action: PayloadAction<BaseProgram>) => {
      state.programDetail = action.payload
    },
    resetProgramDetail: (state) => {
      state.programDetail = initialProgramDetail
    }
  }
})

export const { setBusinessUser, setProgramDetail, resetProgramDetail } =
  transitValidationSlice.actions

export const transitValidationReducer = transitValidationSlice.reducer
